var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9C2.9994 7.62869 3.42596 6.29125 4.2204 5.17351C5.01484 4.05577 6.20472 2.95025 7.5 2.5C8 2.5 7.80302 1.9277 7.88912 1.62134C7.97523 1.31497 8.12678 1.03093 8.33331 0.788819C8.53985 0.546706 8.79645 0.352283 9.08541 0.218963C9.37438 0.0856432 9.68882 0.0166016 10.0071 0.0166016C10.3253 0.0166016 10.6397 0.0856432 10.9287 0.218963C11.2177 0.352283 11.4743 0.546706 11.6808 0.788819C11.8873 1.03093 12.0389 1.31497 12.125 1.62134C12.2111 1.9277 12.2297 2.2491 12.1796 2.56336C13.4728 3.01545 14.7076 3.88242 15.5 5C16.2924 6.11758 17.0014 7.63003 17 9V15L19.9016 17.6004V18.7004H0.101562V17.6004L3 15V9ZM12.2016 19.8004C12.2016 20.3838 11.9698 20.9434 11.5572 21.356C11.1446 21.7686 10.585 22.0004 10.0016 22.0004C9.41809 22.0004 8.85851 21.7686 8.44593 21.356C8.03335 20.9434 7.80156 20.3838 7.80156 19.8004H12.2016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.07b2631d997c3b22d7685fe59ecee82e.svg";
export { ForwardRef as ReactComponent };